module.exports = __webpack_public_path__ + "media/images/icons/building-96a82d8bf3fcd831e9cf2dbf366b168c.png";